import { generatePath } from 'react-router-dom'
import {
  PRODUCT_CATEGORIES,
  PRODUCT_CATEGORIES_UPDATE,
  PRODUCT_CATEGORIES_CREATE,
} from 'constants/api-paths'
import request from './request'
import { formatError } from './error'

export const requestProductCategories = async () => {
  const response = await request.get(PRODUCT_CATEGORIES)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))

  return response
}

export const requestProductCategoriesUpdate = async (id, params) => {
  const path = generatePath(PRODUCT_CATEGORIES_UPDATE, { id })
  const response = await request.patch(path, params)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))

  return response
}

export const requestProductCategoriesCreate = async (params) => {
  const response = await request.post(PRODUCT_CATEGORIES_CREATE, params)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))

  return response
}
